/** @format */

import Alert from '@mui/material/Alert';
import {Box, LinearProgress, Typography} from '@mui/material';
import {Trans} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';
import {useCompanyContext} from 'contexts/CompanyContext';
import {initialAdType} from 'helpers/adTypeHelpers';

import {
  useCreateProfileMutation,
  useGetSharedCompanyQuery,
  useJoinCompanyMutation,
} from '../graphql/__generated__';

const Company = () => {
  const {uuid} = useParams();
  const navigate = useNavigate();

  const {switchAdType, switchCompany} = useCompanyContext();

  const {
    loading: loadingCompany,
    error,
    data,
  } = useGetSharedCompanyQuery({
    skip: !uuid,
    variables: {uuid: uuid!},
  });
  const [createProfile, {loading: createProfileLoading}] = useCreateProfileMutation();
  const [joinCompany, {loading: loadingJoinCompany}] = useJoinCompanyMutation();

  if (error) {
    return <Alert severity='error'>{error.message}</Alert>;
  }
  if (loadingCompany || !data?.sharedCompany || !data?.currentUser) {
    return <LinearProgress style={{flex: 1}} />;
  }

  const {profile} = data.currentUser;

  const handleClick = async () => {
    if (!profile) {
      await createProfile({
        variables: {
          type: 'BUSINESS',
          name: 'Приглашенный пользователь',
          quiz: [],
          budget: 1_000,
        },
      });
    }
    const {data: joinedCompanyData} = await joinCompany({
      variables: {uuid: uuid ?? ''},
    });
    const tokens = joinedCompanyData?.joinCompany.tokens;
    const adType = tokens ? initialAdType(tokens) : null;

    switchCompany(joinedCompanyData?.joinCompany);
    switchAdType(adType);
    navigate('/home/main', {replace: true});
  };

  const companyName = data.sharedCompany.name;

  return (
    <Box
      sx={{
        mt: 4,
      }}
    >
      <Typography>
        <Trans>Вам предоставлен доступ к проекту &#34;{{companyName}}&#34;</Trans>
      </Typography>
      <Box
        sx={{
          mt: 5,
        }}
      >
        <PrimaryMediumButton
          disabled={loadingCompany || loadingJoinCompany || createProfileLoading}
          fullWidth
          onClick={handleClick}
        >
          <Trans>Присоединиться</Trans>
        </PrimaryMediumButton>
      </Box>
    </Box>
  );
};

export default Company;
